import type { WeightedRange } from '../types/solver'

export interface PostflopTrainingSpot {
  id: string
  label: string
  positions: { oop: string; ip: string }
  potBb: number
  effectiveStackBb: number
  ranges: { oop: WeightedRange; ip: WeightedRange }
}

export const POSTFLOP_TRAINING_SPOTS: PostflopTrainingSpot[] = [
  {
    id: 'btn-bb-srp', label: 'BTN vs BB · SRP', positions: { oop: 'BB', ip: 'BTN' }, potBb: 5.5, effectiveStackBb: 97.5,
    ranges: {
      oop: { notation: 'JJ-22,AQs-A2s,AQo-AJo,KQs-K8s,KQo,QJs-Q9s,JTs-J9s,T9s-76s,65s-54s', label: 'BB call vs BTN · baseline' },
      ip: { notation: 'AA-22,AKs-A2s,AKo-A2o,KQs-K2s,KQo-K7o,QJs-Q2s,QJo-Q8o,JTs-J4s,JTo-J8o,T9s-T5s,T9o-T8o,98s-54s,97s-53s,86s-64s,75s,64s,53s', label: 'BTN open · baseline' },
    },
  },
  {
    id: 'co-bb-srp', label: 'CO vs BB · SRP', positions: { oop: 'BB', ip: 'CO' }, potBb: 5.5, effectiveStackBb: 97.5,
    ranges: {
      oop: { notation: 'TT-22,AJs-A2s,AQo-A9o,KQs-K7s,KQo-KTo,QJs-Q8s,QJo-QTo,JTs-J8s,JTo,T9s-65s,97s-64s,86s-75s,54s', label: 'BB call vs CO · baseline' },
      ip: { notation: 'AA-22,AKs-A2s,AKo-A9o,KQs-K6s,KQo-KTo,QJs-Q7s,QJo-QTo,JTs-J7s,JTo,T9s-65s,54s', label: 'CO open · baseline' },
    },
  },
  {
    id: 'sb-bb-srp', label: 'SB vs BB · SRP', positions: { oop: 'SB', ip: 'BB' }, potBb: 6, effectiveStackBb: 97,
    ranges: {
      oop: { notation: 'AA-22,AKs-A2s,AKo-A2o,KQs-K2s,KQo-K7o,QJs-Q3s,QJo-Q8o,JTs-J5s,JTo-J8o,T9s-T5s,T9o-T8o,98s-54s,97s-53s,86s-64s,75s,64s,53s', label: 'SB raise · baseline' },
      ip: { notation: '88-22,A9s-A2s,AJo-A2o,K9s-K2s,KJo-K7o,QTs-Q4s,QJo-Q8o,JTs-J5s,JTo-J8o,T9s-T5s,T9o-T8o,98s-54s,97s-53s,86s-64s,75s,64s,53s', label: 'BB call vs SB · baseline' },
    },
  },
  {
    id: 'btn-bb-3bp', label: 'BTN vs BB · 3-bet pot', positions: { oop: 'BB', ip: 'BTN' }, potBb: 20.5, effectiveStackBb: 90,
    ranges: {
      oop: { notation: 'AA-TT,AKs-AQs,AKo,A5s-A4s,KQs-KJs,QJs,JTs,T9s', label: 'BB 3-bet · baseline' },
      ip: { notation: 'JJ-22,AQs-AJs,AQo,KQs-KJs,QJs,JTs,T9s-76s,65s,A5s-A4s', label: 'BTN call 3-bet · baseline' },
    },
  },
  {
    id: 'btn-sb-3bp', label: 'BTN vs SB · 3-bet pot', positions: { oop: 'SB', ip: 'BTN' }, potBb: 22.5, effectiveStackBb: 89,
    ranges: {
      oop: { notation: 'AA-99,AKs-ATs,AKo-AQo,A5s-A2s,KQs-KJs,KQo,QJs,JTs,T9s', label: 'SB 3-bet · baseline' },
      ip: { notation: 'JJ-22,AQs-A9s,AQo-AJo,KQs-KTs,KQo,QJs-QTs,JTs-J9s,T9s-76s,65s,A5s-A4s', label: 'BTN call SB 3-bet · baseline' },
    },
  },
]
